import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import MarkdownItVue from 'markdown-it-vue'
import i18n from './i18n'
import store from './store'
import {
  PulsCardHeader,
  PulsFormRadio,
  PulsFormInput,
  PulsFormCheckbox,
  PulsNavigationCard,
  PulsNavigationList
} from '@puls-solutions/puls-ui-components'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'markdown-it-vue/dist/markdown-it-vue.css'
import '@puls-solutions/pulsmeter-menu/dist/pulsmeter-menu.css'
import '@puls-solutions/puls-ui-components/dist/puls-ui-components.css'
import '@puls-solutions/puls-good-html/theme/dist/assets/css/style.bundle.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

Vue.config.productionTip = false
Vue.use(MarkdownItVue)
Vue.use(BootstrapVue)
Vue.use(i18n)
Vue.component('puls-card-header', PulsCardHeader)
Vue.component('puls-form-radio', PulsFormRadio)
Vue.component('puls-form-input', PulsFormInput)
Vue.component('puls-form-checkbox', PulsFormCheckbox)
Vue.component('puls-navigation-card', PulsNavigationCard)
Vue.component('puls-navigation-list', PulsNavigationList)

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App)
}).$mount('#app')
